export enum NavigationLayouts {
  ONE = "Navigation 01",
  TWO = "Navigation 02",
  THREE = "Navigation 03",
  FOUR = "Navigation 04",
  FIVE = "Navigation 05",
  SIX = "Navigation 06",
}
